import { useCallback } from "react";
import { useSearchParams } from "react-router";

import { useSearchParamWriter } from "@/hooks/use-search-param-writer";

/** Global homepage value lens (POS2-865): cost (£) or weight (kg). No CO2e — descoped. */
export type Lens = "cost" | "weight";

/**
 * URL-backed lens state consumed by every homepage widget, so the whole page
 * reads in one unit and the choice survives reload/sharing. Default is cost.
 */
export function useLens(): [Lens, (lens: Lens) => void] {
  const [searchParams] = useSearchParams();
  const lens: Lens = searchParams.get("lens") === "weight" ? "weight" : "cost";
  // The dashboard mounts this alongside useWasteFilters, whose site seed writes from an effect —
  // so a lens click and that seed can land in the same commit window (POS2-1048).
  const { write } = useSearchParamWriter({ replace: true });

  const setLens = useCallback(
    (next: Lens) => {
      write((params) => {
        if (next === "cost") params.delete("lens");
        else params.set("lens", next);
      });
    },
    [write],
  );

  return [lens, setLens];
}
